import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import {
  findAllSubscriptionCancellationReasons,
  findAllSubscriptionCancellationReasonsVariables,
} from '__generatedTypes__/findAllSubscriptionCancellationReasons'
import { FIND_ALL_SUBSCRIPTION_CANCELLATION_REASONS } from 'queries/membershipCancellation'
import { CancellationQueryDateFilters } from '../types'

export const useCancellationReasonsStatsQuery = (filters: CancellationQueryDateFilters) => {
  const { platformId, startDate, endDate } = filters

  const variables = useMemo(
    () => ({
      platformId,
      startDate,
      endDate,
    }),
    [platformId, startDate, endDate]
  )

  const { data, loading, error } = useQuery<
    findAllSubscriptionCancellationReasons,
    findAllSubscriptionCancellationReasonsVariables
  >(FIND_ALL_SUBSCRIPTION_CANCELLATION_REASONS, {
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  const reasons = data?.findAllSubscriptionCancellationReasons ?? []
  const totalCancellations = reasons.reduce((sum, item) => sum + item.count, 0)

  return {
    reasons,
    totalCancellations,
    loading,
    error,
  }
}
